<ng-template #signAuthDialogTemplate>
    <form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
        <div class="se-flex se-vertical se-expand">
            <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isOnError">
                <h3 mat-dialog-title translate><span translate>Sign</span> - <span translate>Authenticate</span></h3>
            </div>

            <div class="se-sign-dialog-content" mat-dialog-content [class.se-sign-dialog-waiting]="isWaiting | async">
                <div class="mat-input-container">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "Username" | translate }}</mat-label>
                        <input
                            name="sign_username"
                            matInput
                            [placeholder]="'Signer' | translate"
                            [(ngModel)]="data.info.signerName"
                            tabindex="-1"
                            autocomplete="off"
                            readonly
                        />
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="isPinRequired()">
                        <mat-label>{{ pinLabel | translate }}</mat-label>
                        <input
                            #pin
                            name="sign_pin"
                            [type]="showPin ? 'text' : 'password'"
                            matInput
                            [placeholder]="pinLabel | translate"
                            [(ngModel)]="data.info.pin"
                            autocomplete="new-password"
                            required
                        />
                        <button
                            type="button"
                            matSuffix
                            mat-icon-button
                            aria-label="Show"
                            (click)="showPin = !showPin"
                            tabindex="-1"
                        >
                            <mat-icon>{{ showPin ? "visibility_off" : "visibility" }}</mat-icon>
                        </button>
                        <button
                            *ngIf="!!data.info.pin"
                            type="button"
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="data.info.pin = ''"
                            tabindex="-1"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="isOtpRequired()">
                        <mat-label>{{ "OTP" | translate }}</mat-label>
                        <input
                            #otp
                            name="otp"
                            type="password"
                            matInput
                            [placeholder]="'OTP' | translate"
                            [(ngModel)]="oneTimePwd"
                            autocomplete="new-password"
                            required
                        />
                        <button
                            *ngIf="!!oneTimePwd"
                            type="button"
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="oneTimePwd = ''"
                            tabindex="-1"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>

                    <button
                        *ngIf="canRequestOtpSms()"
                        mat-raised-button
                        color="primary"
                        translate
                        [disabled]="isRequestOtpSmsDisabled$ | async"
                        (click)="onRequestOtpSms($event)"
                    >
                        <div class="otp-sms-button-contents">
                            <span translate>RequestOtpSms</span>
                            <mat-spinner
                                *ngIf="(otpSmsStatus$ | async) === 'loading'; else smsIcon"
                                diameter="20"
                            ></mat-spinner>
                            <ng-template #smsIcon>
                                <mat-icon>sms</mat-icon>
                            </ng-template>
                        </div>
                    </button>

                    <mat-form-field appearance="outline" *ngIf="isTimeoutRequired()">
                        <mat-label>{{ "Timeout" | translate }}</mat-label>
                        <mat-select
                            #signtimeout
                            panelClass="se-mat-select-panel-class"
                            [disableOptionCentering]="true"
                            name="combo-timeout"
                            [placeholder]="timeoutMessage"
                            [(ngModel)]="timeout"
                        >
                            <ng-container>
                                <mat-option [value]="10">10 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="20">20 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="30">30 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="60">60 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="0"><span translate>AlwaysPwd</span></mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-slide-toggle
                        *ngIf="canSessionStayOpen()"
                        class="sign-slide-toggle"
                        labelPosition="after"
                        [checked]="leaveSessionOpen"
                        (change)="leaveSessionOpen = !leaveSessionOpen"
                        [matTooltip]="sessionHelpMsg"
                        matTooltipPosition="right"
                        matTooltipShowDelay="1000"
                    >
                        <span>{{ activeMessage }}</span>
                    </mat-slide-toggle>
                </div>

                <p class="se-sign-dialog-error-message">
                    &nbsp; {{ (errorMessage$ | async) }}
                </p>
            </div>
            <div class="se-sign-dialog-action-container" mat-dialog-actions>
                <button
                    mat-button
                    color="primary"
                    class="se-dialog-action-button"
                    type="button"
                    (click)="closeModal(true)"
                    translate
                >
                    <span translate>Cancel</span>
                </button>

                <button
                    mat-button
                    class="se-dialog-action-button"
                    type="button"
                    color="primary"
                    [disabled]="!enableSignButton()"
                    (click)="closeModal(false)"
                >
                    <span translate>Confirm</span>
                </button>

                <button type="submit" [disabled]="!enableSignButton()" style="display: none">hidden submit</button>
            </div>
        </div>
    </form>

    <div class="estensa-spinner" style="background-color: transparent !important" *ngIf="isWaiting | async">
        <mat-spinner diameter="64" color="accent"></mat-spinner>
    </div>
</ng-template>
